const $ = jQuery.noConflict();
import PerfectScrollbar from 'perfect-scrollbar';

'use strict';
const PSB = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	selectorStyleguideNav: '.js-styleguide-nav-list-holder',
	selectorBasicScroll: '.js-basic-scroll, .select2-results__options',
	classHide: 'hideFade',

	/** @description Initialize */
	init: () => {
		PSB.perfectScrollBarStyleguide();
		PSB.perfectScrollBasicScroll();
	},

	/**
	 * @description Stylequide scrollbar
	 */
	perfectScrollBarStyleguide: () => {
		$(PSB.selectorStyleguideNav).each((i, el) => {
			const selector = $(el)[0];

			const ps = new PerfectScrollbar(selector, {
				wheelSpeed: 1,
				suppressScrollX: true,
				minScrollbarLength: 100
			});

			selector.addEventListener('ps-scroll-y', (e) => {
				const _self = $(e.currentTarget);
				const reach = ps.reach.y;

				reach === 'end' ? _self.parent().addClass(PSB.classHide) : _self.parent().removeClass(PSB.classHide);
			});
		});
	},

	perfectScrollBasicScroll: () => {
		$(PSB.selectorBasicScroll).each((i, el) => {
			if ($(el).hasClass('ps')) return;
			const selector = $(el)[0];
			// eslint-disable-next-line
			const ps = new PerfectScrollbar(selector, {
				wheelSpeed: 0.5,
				suppressScrollX: true,
				minScrollbarLength: 40,
				scrollYMarginOffset: 3
			});

			$(selector).on('mouseenter touchmove', function() {
				if ($(this).hasClass('ps')) {
					PSB.disableScroll();
				}
			});

			$(selector).on('mouseleave touchend', function() {
				PSB.enableScroll();
			});
		});
	},

	preventDefault: (e) => {
		e.preventDefault();
	},

	disableScroll: () => {
		let supportsPassive = false;
		try {
			// eslint-disable-next-line
			window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line
				get: function() {
					supportsPassive = true;
				}
			}));
			// eslint-disable-next-line
		} catch (e) {}
		const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
		const wheelOpt = supportsPassive ? {
			passive: false
		} : false;
		window.addEventListener('DOMMouseScroll', PSB.preventDefault, false); // older FF
		window.addEventListener(wheelEvent, PSB.preventDefault, wheelOpt); // modern desktop
		window.addEventListener('touchmove', PSB.preventDefault, wheelOpt); // mobile
		// window.addEventListener('keydown', preventDefaultForScrollKeys, false);
	},

	enableScroll: () => {
		let supportsPassive = false;
		try {
			// eslint-disable-next-line
			window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line
				get: function() {
					supportsPassive = true;
				}
			}));
			// eslint-disable-next-line
		} catch (e) {}
		const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
		const wheelOpt = supportsPassive ? {
			passive: false
		} : false;
		window.removeEventListener('DOMMouseScroll', PSB.preventDefault, false);
		window.removeEventListener(wheelEvent, PSB.preventDefault, wheelOpt);
		window.removeEventListener('touchmove', PSB.preventDefault, wheelOpt);
		//   window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
	},
};

export default PSB;
